import { phoneNumberRegEx, emailRegEx, linksRegEx } from 'utils/regex'

// the order of these matters since emails gets captured in the linksRegEx
const checkExternalContacts = (message) => {
  // skip 'g' flag in regex - since we only need to check for first match
  if (emailRegEx('imu').test(message)) return true
  if (linksRegEx('imu').test(message)) return false
  if (phoneNumberRegEx('imu').test(message)) return true

  return false
}

export default checkExternalContacts
